import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listUsers:[],
  newUser:[],
  dataSalas:[],
};
export const mutations = {
  GET_USERS({ context }, users) {
    state.listUsers = Object.assign({}, users);
  },
  SAVE_USERS({ context }, user) {
    state.newUser = Object.assign({}, user);
  },
  EDIT_USER({ context }, dataUser) {
    state.dataUser = Object.assign({}, dataUser);
  },
  GET_SALAS({ context }, dataSalas) {
    state.dataSalas = dataSalas.data.salas;
  },
};
export const actions = {
  GET_USERS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getUsers(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_USERS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SAVE_USERS({ commit }, user) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.addUser(user)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_USERS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_USER({ commit }, dataUser) { //axios, mandar parametros para post
    //console.log("store",role);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.editUser(dataUser)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("EDIT_USER", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  DELETE_USER({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.deleteUser(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          // commit("DELETE_USER", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_SALAS({ commit }) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getSalas()
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_SALAS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_TOTALES_BY_SALA({ commit }) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      // commit("SET_LOADING", true);
      ApiService.getTotalesBySala()
        .then(response => {
          // commit("SET_LOADING", false);
          // commit("GET_SALAS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

};

export const getters = {//leer datos
  listUsers: state => state.listUsers,
  newUser: state => state.newUser,
  dataSalas: state => state.dataSalas
};
